export default __webpack_public_path__ + "static/media/appLogoV2.e97cf18d.png";